import { render, staticRenderFns } from "./MatchRoundSelector.vue?vue&type=template&id=e1725f72&scoped=true&"
import script from "./MatchRoundSelector.vue?vue&type=script&lang=js&"
export * from "./MatchRoundSelector.vue?vue&type=script&lang=js&"
import style0 from "./MatchRoundSelector.vue?vue&type=style&index=0&id=e1725f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1725f72",
  null
  
)

export default component.exports